module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Header/images/draw-background.b0b17466.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Header/images/draw-background.jpg
// module id = 3234
// module chunks = 11